export const ICONS = {
  HAM_MENU: 'hamMenu',
  HELP: 'help',
  NOTIFICATION: 'notification',
  PROFILE: 'profile',
}
